import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');
const forEach = require('lodash/forEach');
import { Form, Alert, Modal, Button } from 'react-bootstrap';

const ServerRequest = require('../../actions/request');
const OIDCActions = require('../../actions/OIDCActions');

const propTypes = {
    op: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }).isRequired,
};

const defaultProps = {};

const columnInfo = {
    id: {
        title: 'ID',
        hidden: true
    },
    created_at: {
        title: 'Created At',
        hidden: true
    },
    iss: {
        title: 'Issuer',
        editable: true,
    },
    description: {
        title: 'Description',
        editable: true,
    },
    verbose_logging: {
        title: 'Verbose Logging',
        editable: true,
        type: 'checkbox',
    },
    aud: { 
        title: 'Client ID (aud)',
        editable: true,
        deprecated: true,
    },
    oidc_auth_url: { 
        title: 'OIDC Auth URL',
        editable: true,
        deprecated: true,
    },
    access_token_url: {
        title: 'OAuth2 Access Token URL',
        editable: true,
        deprecated: true,
    },
    jwks_url: { 
        title: 'JWKS URL',
        editable: true,
        deprecated: true,
    },
    num_deployments: {
        title: 'Active Deployments',
        editable: false,
    },
    archived: {
        title: 'Archived',
        hidden: true
    },
};

class AdminOpenIdProviderEditor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...this.getStateFromProps(props),
            canEditIss: false,
            anythingChanged: false,
            statusMessageVisible: false,
            statusMessageState: '',
            statusMessage: ''
        };

        this.updateCanEditIss = this.updateCanEditIss.bind(this);
        this.updateProvider = this.updateProvider.bind(this);
        this.deleteProvider = this.deleteProvider.bind(this);
        this.onChange = this.onChange.bind(this);
    }
    
    getStateFromProps=(props)=>{
        const state = {};
        forEach(columnInfo, (v, k) => {
            state[k] = props.op[k];
        });
        return state;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.op.id === this.props.op.id) return;

        this.setState({ // eslint-disable-line  @eslint-react/no-set-state-in-component-did-update
            ...this.getStateFromProps(this.props),
            canEditIss: false,
            anythingChanged: false,
            statusMessageVisible: false,
            statusMessageState: '',
            statusMessage: ''
        });
    }

    updateCanEditIss=(e)=>{
        this.setState({ canEditIss: !this.state.canEditIss })
    }

    updateProvider=(e)=>{
        const self = this;
        var changes = {};
        forEach(columnInfo,(v, k) => {
            if (v.editable) {
                changes[k] = this.state[k];
            }
        });
        
        if (confirm("Are you sure you want to update this record?")) {
            ServerRequest.makeRequest((`/authoring/oidc/provider/${this.props.op.id}/update`), 'POST', JSON.stringify({
                    opId: self.props.op.id,
                    changes: changes
                }))
                .then((res) => {
                    this.setState({
                        statusMessageVisible: true,
                        statusMessageState: 'success' ,
                        statusMessage: 'OpenID Provider Updated',
                    });
                    OIDCActions.getOpenIdProviders(uuid.v4()); // trigger a data refresh
                })
                .catch((err) => {
                    console.log("error", err);
                    this.setState({
                        statusMessageVisible: true,
                        statusMessageState: 'danger' ,
                        statusMessage: 'There was a problem updating the OpenID Provider',
                    });
                });
        }
    }

    deleteProvider=(e)=>{
        const self = this;
        if (confirm("Are you sure you want to delete the LMS deployment?")) {
            this.setState({ anythingChanged: false }, () => { // disable the update button while we're sending the update
                ServerRequest.makeRequest((`/authoring/oidc/provider/${this.props.op.id}/delete`), 'POST', JSON.stringify({
                        opId: self.props.op.id
                    }))
                    .then((res) => {
                        console.log("deleted", res);;
                        OIDCActions.getOpenIdProviders(uuid.v4()); // trigger a data refresh
                    })
                    .catch((err) => {
                        console.log("error", err)
                        this.setState({
                            statusMessageVisible: true,
                            statusMessageState: 'danger' ,
                            statusMessage: 'There was a problem deleting the OpenID Provider',
                        });
                    });
            }); 
        }
    }
    
    onChange=(key,value)=>{
        const changes = {};
        changes[key] = value;
        let anythingChanged = false;
        forEach(columnInfo, (v, k) => {
            if (v.editable) {
                const state_val = (key === k) ? value : this.state[k];
                if (this.props.op[k] !== state_val) {
                    anythingChanged = true;
                }
            }
        })
        changes.anythingChanged = anythingChanged;
        this.setState(changes);
    }
    
    render() {
        const entries = [];
        let anyDeprecatedFields = false;
        forEach(columnInfo,(v,k)=>{
            if (v.deprecated && this.state[k]) {
                anyDeprecatedFields = true; 
            }
        });
        
        forEach(columnInfo,(v,k)=>{
            if (!anyDeprecatedFields && v.deprecated) {
                return; // don't show deprecated fields if they've all been blanked
            }
            if (!v.hidden) {
                const isIss = (k === 'iss');
                let disabled = !v.editable;
                if (isIss && !this.state.canEditIss) {
                    disabled = true;
                }
                entries.push (
                    <Form.Group key={k} controlId={"admin-" +k}>
                        { v.type === 'checkbox' ? 
                        <input
                            type="checkbox"
                            checked={this.state[k]}
                            disabled={disabled}
                            readOnly={disabled}
                            onChange={(e) => { if (v.editable) { this.onChange(k, e.target.checked) } } }
                        />
                        : null }
                        <Form.Label>{v.title}</Form.Label>
                        { v.type == 'checkbox' ? null :
                        <Form.Control
                            type="text"
                            // className="openid-provider-field"
                            size="lg"
                            aria-label={v.title}
                            value={this.state[k] || ''}
                            onChange={(e) => { if (v.editable) { this.onChange(k, e.target.value) } } }
                            disabled={disabled}
                            readOnly={disabled}
                        />
                        }
                        {(isIss) &&
                            <Button onClick={this.updateCanEditIss}>
                                <i className={!this.state.canEditIss ? 'fa fa-lock' : 'fa fa-unlock-alt'} aria-hidden="true" />
                            </Button>
                        }
                    </Form.Group>
                );
            }
        })
        
        return (
            <Modal
                size="xl"
                show
                enforceFocus={false}
                backdrop={false}
                animation={false}
                keyboard
                onHide={this.props.closeHandler}
            >
                <Modal.Header closeButton onHide={this.props.closeHandler}>
                    <Modal.Title>Edit OpenId Provider</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {(this.state.statusMessageVisible) &&
                        <Alert variant={this.state.statusMessageState}>
                            <h4>{this.state.statusMessage}</h4>
                        </Alert>
                    }
                    {entries}
                    <Button onClick={this.updateProvider} disabled={!this.state.anythingChanged}>
                        Update
                    </Button>
                    <Button variant="danger" onClick={this.deleteProvider} disabled={Number(this.state.num_deployments) > 0}>
                        Delete
                    </Button>
                </Modal.Body>
            </Modal>
        );
    }
}

AdminOpenIdProviderEditor.propTypes = propTypes;
AdminOpenIdProviderEditor.defaultProps = defaultProps;

export default AdminOpenIdProviderEditor;